module.exports = require("./th-TH.js");